<template>
  <div class="secondpage">
    <div class="title_top">
      <el-row :gutter="20">
        <el-col
          :span="16"
          :offset="4"
          :class="this.isMobile() ? 'secondpage_con_ydd' : 'secondpage_con'"
        >
          <div>
            <el-button :class="!this.isMobile() ? 'join-button':'join-buttonydd'" @click="openJoin"
              >申请开店</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 生成二维码 -->
    <!-- <div class="qrcode" ref="qrCodeUrl"></div> -->


    <!-- 申请开店注册流程 -->
    
    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <div class="open">
        <h2>开店流程</h2>
        <p>
          <i class="iconfont icon-number_one">. 手机下载东方集市商家端App</i
          >{{ "&nbsp&nbsp&nbsp------&nbsp&nbsp&nbsp"
          }}<i class="iconfont icon-number_two"
            >. 打开手机App，点击“我要开店”开始入驻</i
          >
        </p>
      </div>
      <div class="openImg">
        <img src="../assets/businessDownload.png" alt="" />
        {{
          "&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp"
        }}
        <img src="../assets/open.png" alt="" style="margin-left: -20px" />
      </div>
    </el-dialog>
    <!-- 手机端开店注册流程 -->

    <van-popup
      v-model:show="show"
      round
      position="bottom"
      :style="{ height: '75%' }"
    >
      <div class="ydd-popup">
        <h2>开店流程</h2>
        <p>
          <i class="iconfont icon-number_one">. 手机下载东方集市商家端App</i>
          <img src="../assets/openydd.png" alt="" style="width:60%;"/>
          <!-- <div class="qrcode" ref="qrCodeUrl" ></div> -->
          </p>
          <p>
          <i class="iconfont icon-number_two">. 打开手机App，点击“我要开店”开始入驻</i>
          <img src="../assets/open.png" alt="" style="width:60%;margin-left:4%" />
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup } from "vant";
import { ref } from "vue";
import QRCode  from 'qrcodejs2';
Vue.use(Popup);
export default {
  setup() {
    const show = ref(false);
    const showPopup = () => {
      show.value = true;
    };
    return {
      show,
    };
  },

  data() {
    return {
      dialogVisible: false,
      workTask: [],
    };
  },
  created() {
    this.workTask = this.$route.query.id;
    console.log(this.workTask);
  },
  mounted() {
    // this.creatQrCode();
},
  methods: {

    //生成二维码
    //  creatQrCode() {
    //     var qrcode = new QRCode(this.$refs.qrCodeUrl, {
    //         text: 'https://df-js.cn/businessDown', // 需要转换为二维码的内容
    //         width: 100,
    //         height: 100,
    //         colorDark: '#000000',
    //         colorLight: '#ffffff',
    //         correctLevel: QRCode.CorrectLevel.H
    //     })
    // },




    openJoin() {
      
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent) ) {
       this.show = true;
      } else {
         this.dialogVisible = true;
        
      }
    },
    isMobile() {
      
      let flag = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? true : false;
    },
  },
};
</script>

<style scoped>

.qrcode {
  display: inline-block;
  width: 100px;
  height: 100px;
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}

.ydd-popup {
  color: #333;
}
.open p {
  font-size: 15px !important;
}
.join-button {
  
  /* width: 100px;
    height: 48px;
    line-height: 48px;
    
    margin-left: 0; */

  position: absolute;
  left: 21.6%;
  top: 68%;
  width: 8.5rem;
  height: 2.5rem;
  line-height: 1rem;
  background: #ffd161;
  border-radius: 2px;
  font-size: 1.1111rem;
  color: #333;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font-weight: 700;
}
.join-buttonydd{
  position: absolute;
  left: 8.6%;
  top: 68%;
  width: 6.5rem;
  height: 1.7rem;
  line-height: 0.24rem;
  background: #ffd161;
  border-radius: 2px;
  font-size: 0.9rem;
  color: #333;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font-weight: 700;
}
.title_top {
  width: 100%;
  overflow: hidden;
  margin: 0;
  color: #ffffff;
  background: url(../assets/sj.jpg) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.openImg img {
  width: 45%;
}

.secondpage_con {
  margin: 280px auto;
}
.secondpage_con_ydd {
  margin: 105px auto;
}

.content {
  margin: 50px auto;
}

.content h2,
.content h3,
.content p {
  color: #000000;
}

.content p {
  font-size: 14px;
  color: #475669;
}

.box_cont {
  padding: 10px;
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/business.vue